import React, { useState, useEffect } from "react";
import { loadShoppingLists, loadShoppingList } from "./Fetching";
import { post } from "../../lib/Fetching";
import Link from "../Link";
import Button from "../Button";
import ShoppingList from "./ShoppingList";
import ShoppingListRegisterButtons from "./ShoppingListRegisterButtons";

export default function ShoppingLists({
  company_id,
  branch_id,
  registerShoppingList,
  registerItems
}) {
  const [lists, setLists] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [route, setRoute] = useState("shopping_lists");
  const [listId, setListId] = useState(null);

  const fetchShoppingLists = () => {
    loadShoppingLists({ company_id, branch_id }).then(json => {
      setLists(json.shopping_lists);
      setLoaded(true);
    });
  };

  useEffect(fetchShoppingLists, []);

  const deleteList = list => {
    if (confirm(I18n.t("are_you_sure_you_want_to_delete_this_list"))) {
      post("/products/shopping_lists/" + list.id, {}, "DELETE").then(fetchShoppingLists);
    }
  };

  const selectList = list => {
    setListId(list.id);
    setRoute("view_list");
  };

  const showList = () => {
    return <ShoppingList id={listId} registerItems={registerItems} />;
  };

  const renderShoppingLists = () => {
    if (lists.length === 0) {
      return <p className="alert alert-default">{I18n.t("there_are_no_lists_setup")}</p>;
    }
    return (
      <div>
        <table className="table table-condensed table-hover">
          <thead>
            <tr>
              <th style={{ maxWidth: 100 }}>&nbsp;</th>
              <th>{I18n.t("list_name")}</th>
              <th className="text-center" style={{ width: 160 }}>
                {I18n.t("sample_count")}
              </th>
              <th className="text-center">{I18n.t("created_at")}</th>
              <th style={{ width: 80 }} />
            </tr>
          </thead>
          <tbody>
            {lists.map(list => (
              <tr key={list.id}>
                <td style={{ paddingRight: 20 }}>
                  <ShoppingListRegisterButtons registerItems={registerItems} list={list} />
                </td>
                <td style={{ whiteSpace: "nowrap", width: 200 }}>
                  <Link onClick={() => selectList(list)}>{list.name}</Link>
                </td>
                <td className="text-center">
                  {list.sample_count} {I18n.t("samples")}
                </td>
                <td className="text-center">{list.created_at_f}</td>
                <td className="text-center">
                  <Link onClick={() => deleteList(list)}>
                    <i className="fa fa-trash" />
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  if (route === "shopping_lists") return renderShoppingLists();
  if (route === "view_list") return showList();
}
